import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { timeHorizonOpts } from './TimeHorizon.meta';
import { MarginProps } from '../../../../theme/styledProps';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

const fieldName = 'timeHorizon';

export const TimeHorizon: React.FC<MarginProps> = props => {
  const formBag = useFormContext();

  return (
    <Wrapper {...props}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={timeHorizonOpts.find(({ value }) => value === field.value)}
            label="What is your time horizon for your investments?"
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);
              }
            }}
            options={timeHorizonOpts}
          />
        )}
      />
    </Wrapper>
  );
};
